// extracted by mini-css-extract-plugin
export default {"container":"Input_container__JKv5a","label":"Input_label__H05ZB","input":"Input_input__JxtHe"};